
<template>
  <div>
    <div class="permission-alert-msg" v-show="!ifTeamleaderAnchorPermission">
      You have only view permission.
    </div>
    <div class="row">
      <div class="alignPaygrp">
        <span>Exits</span>
        <br />
        <div class="paygrps-info">
          <b>{{exitsCount}}</b>
        </div>
      </div>
      <div class="alignPaygrp">
        <span>Total Employees</span>
        <br />
        <div class="paygrps-info">
          <b>{{totalEmployee}}</b>
        </div>
      </div>
    </div>
    <div class="d-payroll__group margin-t-l">
      <div class="d-heading2 d-flexbox">Add Exiting Employees</div>
      <br />
    </div>
    <div class="uploadMethoRadio" :disabled="!ifTeamleaderAnchorPermission">
      <tl-radio
        name="uploadType"
        label="Bulk Upload"
        id="bulkUpload"
        value="bulkUpload"
        v-model="uploadMethod"
      />
      <tl-radio
        name="uploadType"
        label="Manual"
        id="manualUpload"
        value="manualUpload"
        v-model="uploadMethod"
      />
    </div>
    <toast-message
      :message="errmsg"
      type="error"
      :isToastEnable="toast"
      @close="(val) => toast = val"
    />
    <div v-if="uploadMethod == 'manualUpload'">
      <div class="searchclass" :disabled="!ifTeamleaderAnchorPermission">
        <search-dropdown
          label="Employee Code / Name"
          v-model="searchText"
          :employeeData="employeeData"
          @getList="searchDataList($event)"
          @empselected="(emp)=>selectedEmp(emp)"
        />
      </div>

      <div class="card margintop-20" v-if="isEmployeeSelected">
        <div class="image">
          <img
            v-if="employeeCard.photo_url"
            :src="employeeCard.photo_url"
            alt="img"
            class="alignImage"
          />
          <img v-else src="@/assets/user.svg" class="alignImage" />
        </div>
        <div class="emp-details">
          <span>
            <b>{{employeeCard.name}}</b>
          </span>
          <br />
          <span class="details">{{employeeCard.code}}</span>
          <br />
          <span class="details">{{employeeCard.email_id}}</span>
          <br />
          <br />
        </div>
      </div>

      <div class="extra-filters" :disabled="!ifTeamleaderAnchorPermission">
        <tl-select
          label="Reason For Exit *"
          labelText="name"
          name="Reason"
          v-model="employeeObject.reason"
          :options="exitReasonsArray"
          @change="exitReasonChanged($event)"
          v-validate="'required'"
          :classname="errors.has('Reason')"
          :errormsg="errors.first('Reason')"
        />

        <div class="selectdiv">
          <span class="input-label">Resignation Date *</span>
          <date-picker
            @datevalue="updateDateValues"
            name="Resignation date"
            v-model="employeeObject.resignation_date"
            :disable="!employeeCard.date_of_joining"
            :dates-disabled="{from: new Date() , to: new Date(employeeCard.date_of_joining) }"
            v-validate="'required'"
            :classname="errors.has('Resignation date')"
            :errormsg="errors.first('Resignation date')"
          />
        </div>

        <div class="selectdiv">
          <span class="input-label">Last Working Day *</span>
          <date-picker
            @datevalue="(val)=>employeeObject.last_working_date=val"
            name="Last Working Day"
            v-model="employeeObject.last_working_date"
            :disable="employeeObject.resignation_date==''"
            :dates-disabled="{to: resignation_date}"
            v-validate="'required'"
            :classname="errors.has('Last Working Day')"
            :errormsg="errors.first('Last Working Day')"
          />
        </div>
      </div>
      <div class="remarks-grid margin-b-l" :disabled="!ifTeamleaderAnchorPermission">
        <div class>
          <txt
            type="textarea"
            label="Remarks *"
            v-model="employeeObject.remarks"
            name="remarks"
            v-validate="'required'"
            :classname="errors.has('remarks')"
            :errormsg="errors.first('remarks')"
          ></txt>
        </div>
      </div>
      <div>
        <div class="selectedComp">
          <div v-for="(data,index) in addedEmployeeForExitsList" :key="index">
            <div class="rect">
              <button>
                <span>
                  {{ data.employeeName }}
                  <img src="@/assets/group-6.svg" @click="removeTag(index)" />
                </span>
              </button>
            </div>
          </div>
        </div>
      </div>

      <btn text="Add Employee" type="secondary" v-on:click="addEmployee" :disabled="!ifTeamleaderAnchorPermission"></btn>

      <footer>
        <bottom-action-container>
          <template slot="end">
            <btn-grp class="form-button">
              <btn text="Cancel" type="secondary" @click="cancel" />
              <btn text="Submit" type="primary" @click="submit" :disabled="!ifTeamleaderAnchorPermission"></btn>
            </btn-grp>
          </template>
        </bottom-action-container>
      </footer>
    </div>
    <div v-else>
      <div class="download-btn">
        <!-- <download-button
          onclick="location.href='https://dev-opn-test1.s3.ap-south-1.amazonaws.com/paylief-bulk-upload-templates/Template-+Exit+employee.xlsx'"
        ></download-button> -->
        <download-button class="margin-l-m margin-t-m" @downloadTemplate="downloadTemplate()"></download-button>
      </div>
      <upload-file :apiUrl="bulkUploadUrl" @uploadTemplate="onUploadTemplate($event)" />
    </div>

    <pop-up-message
      v-if="showSuccessMsg"
      :message="`Resginee's Added Successfully!`"
      btnText="Back To Add Exit Employees"
      @back="backToAddExitEmployeesPage"
    ></pop-up-message>

    <pop-up-message
      v-if="showBulkUploadSuccessMsg"
      :message="`${popupMessage}`"
      btnText="Back To Payroll Utilities"
      @back="back"
    ></pop-up-message>
    <pop-up-message
      v-if="showErrorPopup"
      popupType="Warning"
      :popupHeaderMessage="'UPLOAD FAILED!!!'"
      :message="`${popupMessage}`">
      
      
        <template v-slot:bottomContent>
        <div class=" margintop-32">
          <div class="Rectangle margintop-32">
          <span class="Information-message">{{ logMessage }}</span>
        </div>
      </div>
      <div class="margintop-32 custom-container">
      <a :href="logSheetUrl"
        @click="downloadItem(logSheetUrl)"
      ><img src="@/assets/download.svg"  class="img" /> <span class="text">Error Log Sheet</span></a>
          </div>
          <div class="popup-btn-group margintop-32 marginright">
            <button class="btn-popup" type="button" @click="back()">Back To Payroll Utilities</button>
          </div>
        </template>
    </pop-up-message>
  </div>
</template>


<script>
import { mapActions, mapGetters, mapState } from "vuex";
import SearchDropdown from "@/components/TlSearchDropdown.vue";
import { api_variables } from "@/apis/variables.js";

export default {
  name: "AddExitEmployees",
  components: {
    SearchDropdown
  },
  data() {
    return {
      bulkUploadUrl: api_variables.SERVICE_EMP_EXITS_UPLOAD_TEMPLATE,
      selectedEmployeeDateOfJoining: null,
      searchText: "",
      empCN: "abc123",
      empName: "",
      empId: "",
      legalentity: "All",
      sort: "Recently Joined",
      search: "",
      uploadMethod: "manualUpload",
      showSuccessMsg: false,
      initiation_date: "",
      last_working_date: "",
      reason_for_exit: "",
      remarks: "",
      totalEmployee: "",
      selectedEmpArray: [],
      resignation_date: "",
      exitreasonOptions: ["Resigned", "Fired"],
      exitReasonsArray: [
        {
          id: "Absconding",
          name: "Absconding"
        },
        {
          id: "Death",
          name: "Death"
        },
        {
          id: "Termination",
          name: "Termination"
        },
        {
          id: "Resigned",
          name: "Resigned"
        },
        // {
        //   id: "Fired",
        //   name: "Fired"
        // },
        {
          id: "Retirement/ Super Annutation",
          name: "Retirement/ Super Annutation"
        }
      ],
      columnNames: [
        {
          label: "",
          key: "image"
        },
        {
          label: "Code",
          key: "code"
        },
        {
          label: "Name",
          key: "name"
        },
        {
          label: "Department",
          key: "department"
        },
        {
          label: "Leave Requests",
          key: "leaverequests"
        },
        {
          label: "Compo Off Requests",
          key: "compooffrequests"
        },
        {
          label: "Reimbursement Claims",
          key: "reimbursementclaims"
        },
        {
          label: "FBP Claims",
          key: "fbpclaims"
        }
      ],
      employeeData: [],
      auto_suggestions: false,
      filterEmpData: [],
      showDataTable: false,
      exitsCount: 0,
      showTagIndex: "",

      errmsg: "",
      toast: false,
      showBulkUploadSuccessMsg: false,
      showErrorPopup: false,
      popupMessage: "",

      addedEmployeeForExitsList: [],
      employeeObject: {
        empId: null,
        reason: null,
        resignation_date: "",
        last_working_date: "",
        remarks: null,
        employeeName: null
      },
      isEmployeeSelected: false,
      employeeCard: {
        name: null,
        code: null,
        email_id: null,
        photo_url: null,
        date_of_joining: null
      },
      exitEmployeeDetailsValue: false,
      role: ""
    };
  },
  activated() {
    this.$validator.reset();
    this.refresh();
    this.fetchAll();
    this.fetchEmplDetails(); // fetch all employees
    this.getOrgLeIdList();
  },
  mounted() {
    this.fetchAll();
    this.fetchEmplDetails(); // fetch all employees
    this.getOrgLeIdList();
  },

  beforeDestroy() {
    this.refresh();
  },

  destroyed() {
    this.refresh();
  },

  computed: {
    ...mapGetters({
      getleid: "onboard/legal_entities/legal_entity_ID"
    }),
    ...mapState({
      employeesExitsData: state => state.dashboard.add_exit_employees.exits,
      employeesJoiningsData: state => state.payroll.joinings.joinings //fetch all employees data
    }),
    le_id() {
      if (this.$route.params.entity_index)
        return this.getleid(this.$route.params.entity_index);
      else return this.getleid(0);
    },
    ...mapState("onboard/organization", {
      orgId: state => state.id
    }),
    ifTeamleaderAnchorPermission() {
        if(this.role === 'TEAMLEADER' || this.role === 'ANCHOR' || this.role === 'ADMIN') {
          if(this.exitEmployeeDetailsValue) {
            return true;
          } else {
            return false;
          }
        } 
        // else {
        // return true 
        // }
    }
  },
  methods: {
    filterData(searchText) {
      this.search = searchText;
    },
    deleteData() {
      this.showDataTable = false;
    },
    backToAddExitEmployeesPage() {
      this.showSuccessMsg = false;
    },
    updateDateValues(value, dateObj) {
      try {
        this.employeeObject.resignation_date = value;
        this.employeeObject.last_working_date = "";
        this.resignation_date = dateObj;
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },

    ...mapActions({
      act_fetchAll: "dashboard/payroll/utilities/addexitemployees/fetchExits",
      act_create: "dashboard/payroll/utilities/addexitemployees/create",
      act_fetchAllEmployees: "globalapi/globalemployees/fetchAll",
      act_upload_template:
        "dashboard/payroll/utilities/addexitemployees/uploadTemplate",
      act_fetchLegalEntityNonExitsEmployeeSearchList:
        "dashboard/payroll/utilities/addexitemployees/fetchLegalEntityNonExitsEmployeeSearchList",
        act_download_template: "dashboard/payroll/utilities/addexitemployees/downloadTemplate"
    }),

    async downloadTemplate() {
      try {
      let data={
         le_id : this.le_id,
        }
        let res = await this.act_download_template(data);
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    /** Function to search the employee by name */
    searchDataList(val) {
      this.getEmployeesByName(val);
    },
    /** Function to fetch the list of employees by name */
    async getEmployeesByName(val) {
      try {
        let obj = {
          key: val,
          le_id: this.le_id
        };
        let res = await this.act_fetchLegalEntityNonExitsEmployeeSearchList(
          obj
        );
        this.employeeData = [];
        if (res.data.payload) {
          let payloadArray = res.data.payload ? res.data.payload : [];
          this.employeeData = payloadArray;
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    /** On Bulk upload Previous Implementation*/
    /*
    async onUploadTemplate(event) {
      let formData = new FormData();
      formData.append("file", event);
      formData.append("le_id", this.le_id);
      try {
        let res = await this.act_upload_template(formData);
        if (res.status == 200 || res.status == 201) {
          this.popupMessage = res.message ? res.message : "";
          this.showBulkUploadSuccessMsg = true;
        }
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },
    */


    /* function to get response after uploading in bulk */
    async onUploadTemplate(response) {
      try {
          let res = response.response;
          if(response.data.message == 'Failed'){
            this.popupMessage = response.data.message ? response.data.message : "";
            this.showErrorPopup = true;
            this.logSheetUrl = response.data.payload[0];
          }
          else if (response.data && response.data.status) {
            this.popupMessage = response.data.message ? response.data.message : "";
            this.showBulkUploadSuccessMsg = true;
          } else {
            this.toast = true;
            this.errmsg = res.data.message;
          }
      } catch (err) {
        this.$root._data.isSaving = false;
        this.toast = true;
        this.errmsg = err;
      }
    },


    /** Function to remove the selected employee */
    removeTag(index) {
      try {
        if (this.showTagIndex !== null) {
          this.showTagIndex = this.showTagIndex == index ? null : index;
        } else {
          this.showTagIndex = index;
        }

        this.addedEmployeeForExitsList.splice(index, 1);
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },
    /** To fetch the Employee exits list */
    async fetchAll() {
      try {
        let res = await this.act_fetchAll(this.le_id);
        this.exitsCount = res.data.payload.length;
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },
    /** To fetch all the employees list */
    async fetchEmplDetails() {
      let tempObj = {};
      try {
        let res = await this.act_fetchAllEmployees({ le_id: this.le_id });
        this.employeeData = [];
        this.salaryData = [];
        this.totalEmployee = res.data.payload.data.length;
        for (var i = 0; i < res.data.payload.data.length; i++) {
          for (
            var j = 0;
            j < res.data.payload.data[i].EmployeeSalarySetting.length;
            j++
          ) {
            tempObj =
              res.data.payload.data[i].EmployeeSalarySetting[j]
                .master_salary_structure.obj;
          }
        }
        for (var key in tempObj) {
          let salaryObj = {
            code: tempObj[key].name,
            currentSalary: tempObj[key].monthly,
            revisedSalary: tempObj[key].value
          };
          this.salaryData.push(salaryObj);
        }
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },
    /**  To search an employee by name */
    searchData(key, array) {
      try {
        const final = [];
        for (let i = 0; i < array.length; i++) {
          let searchObj = array[i].first_name;
          if (
            searchObj != null &&
            searchObj.toLowerCase().search(key.toLowerCase()) !== -1
          ) {
            final.push(array[i]);
          }
        }
        return final;
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },

    filterData(searchText) {
      try {
        let data = this.$_.cloneDeep(this.employeeData);
        if (searchText.length) {
          this.auto_suggestions = true;
          this.filterEmpData = this.searchData(searchText, data);
        } else {
          this.auto_suggestions = false;
        }
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },
    /** On seleteced employee card click in search bar */
    selectedEmp(emp) {
      try {
        this.selectedEmpArray.push(emp);
        this.empName = emp.name;
        this.empId = emp.code;

        this.employeeCard = {
          name: emp.first_name,
          code: emp.code,
          email_id: emp.email,
          photo_url: emp.photo_url,
          date_of_joining: emp.EmployeeOfficial
            ? emp.EmployeeOfficial.date_of_joining
            : null /** PL_1673 */
        };

        this.employeeObject.resignation_date = null;
        this.employeeObject.last_working_date = null;

        this.employeeObject.employeeName = emp.name;
        this.employeeObject.empId = emp.id;
        this.isEmployeeSelected = true;
        this.selectedEmployeeDateOfJoining = null;
        let dateOfJoining = emp.EmployeeOfficial
          ? emp.EmployeeOfficial.date_of_joining.substring(0, 10)
          : null;
        this.selectedEmployeeDateOfJoining = dateOfJoining;
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },
    /** Navigation */
    back() {
      try {
        this.showErrorPopup = false;
        this.showBulkUploadSuccessMsg = false;
        this.$router.push({
          path: `/dashboard/${this.$route.params.entity_index}/payroll/utilities`
        });
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },
    /** Exits reason drop down change */
    exitReasonChanged(event) {
      try {
        this.employeeObject.reason = event;
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },
    /** Function to validate the form data and to add the employee to exit list request */
    addEmployee() {
      try {
        this.$validator.validateAll().then(result => {
          if (result) {
            if (this.addedEmployeeForExitsList.length) {
              let index = this.addedEmployeeForExitsList.findIndex(
                item => item.empId === this.employeeObject.empId
              );
              if (index > -1) {
                this.toast = true;
                this.errmsg =
                  "This employee is already selected. Please select another employee";
                return;
              } else {
                this.addedEmployeeForExitsList.push(this.employeeObject);
                this.toast = false;
                this.errmsg = "";
              }
            } else {
              this.addedEmployeeForExitsList.push(this.employeeObject);
            }
            this.employeeObject = {
              empId: null,
              reason: null,
              resignation_date: null,
              last_working_date: null,
              remarks: null,
              employeeName: null
            };

            this.employeeCard = {
              name: null,
              code: null,
              email_id: null,
              photo_url: null,
              date_of_joining: null
            };
            this.isEmployeeSelected = false;
            this.addedEmployeeForExitsList = [
              ...this.addedEmployeeForExitsList
            ];
          }
        });
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },

    cancel() {
      this.refresh();
      this.$router.go(-1);
    },
    /** Function to check whether atleast one employee is added to exit or not */
    submit() {
      try {
        if (this.addedEmployeeForExitsList.length) {
          this.toast = false;
          this.errmsg = "";
          this.performAction();
        } else {
          this.toast = true;
          this.errmsg = "Please select atleast one employee to exit";
        }
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },
    /** Function to submit the form data to server */
    async performAction() {
      try {
        let finalArr = [];

        if (this.addedEmployeeForExitsList.length > 0) {
          this.addedEmployeeForExitsList.forEach((item, index) => {
            let obj = {
              le_id: this.le_id,
              employee_id: item.empId,
              initiation_date: item.resignation_date,
              last_working_date: item.last_working_date,
              reason_for_exit: item.reason ? item.reason.id : null,
              remarks: item.remarks
            };
            finalArr.push(obj);
          });

          let obj = {
            data: finalArr
          };
          try {
            this.$root._data.isSaving = true;
            let res = await this.act_create(obj);
            setTimeout(() => {
              if (res.data.status) {
                this.showSuccessMsg = true;
                this.fetchAll();
                this.refresh();
              }
              this.$root._data.isSaving = false;
            }, 500);
          } catch (error) {
            this.$root._data.isSaving = false;
            this.toast = true;
            this.errmsg = error;
          }
        }
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },
    /** Function to clear the form data */
    refresh() {
      try {
        this.initiation_date = "";
        this.resignation_date = "";
        this.last_working_date = "";
        this.reason_for_exit = "";
        this.remarks = "";

        this.employeeObject = {
          empId: null,
          reason: null,
          resignation_date: "",
          last_working_date: "",
          remarks: null,
          employeeName: null
        };
        this.isEmployeeSelected = false;
        this.addedEmployeeForExitsList = [];
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },

    ...mapActions({
        getOrgLeList: "onboard/organization/getOrgLeIdList",
    }),

    async getOrgLeIdList() {
        const org = this.orgId;
        const le = this.le_id;
        //console.log("Org:",org);
        //console.log("Le ID",le);
        let bodyParams = {};
        let  data = await this.getOrgLeList({
          data: {
            ...bodyParams
          }
        });
        this.role = data.data.user.userRole;
        this.exitEmployeeDetailsValue = data.data.user.permissions.exit_employee_details ? true : false;
        //console.log("PL-3406",data);
    }
  }
};
</script>

<style lang="scss" scoped>
.card {
  display: flex;
  width: 27%;
  margin-right: 12px;
  margin-bottom: 20px;
  height: 100px;
  border-radius: 10px;
  border: solid 1px #cccfce;
  background-color: #ffffff;
}

.image {
  .alignImage {
    width: 60px;
    height: 60px;
    margin: 20px;
  }
}

.emp-details {
  padding: 25px 0 0 10px;
  color: #535353;
}

.paygrpsDiv {
  display: flex;
  cursor: pointer;
  grid-template-columns: repeat(4/2fr);
  grid-template-rows: auto;
  grid-gap: 2px;
  margin-top: 35px;
  margin-bottom: 35px;
  span {
    color: #646464;
    font-size: 16px;
  }
}
.paygrps-info {
  color: #646464;
  cursor: pointer;
  text-align: center;
  b {
    font-size: 24px;
  }
}
.alignPaygrp {
  margin-right: 50px;
  margin-left: 13px;
}
.text-area {
  width: 759px;
  height: 85px;
  border-radius: 4px;
  border: solid 1px #c6c9c8;
  background-color: #ffffff;

  &:focus {
    outline: none;
    border: 2px solid #37c6c0;
  }
}
.content {
  margin-left: 20px;
  margin-top: 15px;
}
.subtitle {
  width: 316px;
  height: 15px;
  font-family: Montserrat;
  font-size: 12px;
  color: #646464;
}
.main-header {
  color: #6d6d6d;
  margin-top: 25px;
  font-size: 16px;
}
.uploadMethoRadio {
  display: flex;
  margin-bottom: 2%;
}
.line {
  border-bottom: 1px solid #c8c8c8;
  width: 100%;
  margin-bottom: 20px;
  margin-top: 10px;
}
.bottom-line {
  border-bottom: 1px solid #34c0be;
  width: 100%;
  margin-bottom: 20px;
  margin-top: 15%;
}
select .dropdown {
  border-radius: 4px;
  border: 1px solid #dadada;
  padding: 10px;
  transition: ease-in-out, width 0.35s ease-in-out;

  &:focus {
    outline: none;
    border: 2px solid #37c6c0;
  }
}

.selectdiv {
  select {
    width: 100%;
    border-radius: 4px;
    outline: 0;
    font-size: 14px;
    color: #9f9da2;
    border: 1px solid #dadada;
    padding: 0 10px;

    &.errorr {
      border: 1px solid #e01717;
    }
    &.errorMessage {
      color: #e01717;
    }
  }
  span {
    font-size: 12px;
    margin-left: 3px;
    color: #9f9da2;
  }
}
.recent {
  align-self: self-end;
}
.selectedComp {
  display: flex;
  flex-wrap: wrap;
  width: 538px;
  min-height: 80px;
  border-radius: 8px;
  // border: solid 1px #dadada;
  background-color: #ffffff;
  margin-top: 1.1%;
}
.rect {
  padding: 5px 10px 5px 10px;
  margin: 2px;
  height: 30px;
  border-radius: 15px;
  background-color: #c7efef;
  text-align: center;
}
.extra-filters {
  display: grid;
  grid-gap: 10px;
  grid-template-columns: 0.2fr 0.2fr 0.2fr;
  margin-bottom: 2%;
  margin-top: 1%;
}
.remarks {
  margin-bottom: 2%;
}
.remarks-label {
  font-size: 12px;
  color: #c6c9c8;
}
.filterbtn {
  width: 80%;
  height: 65%;
  border-radius: 4px;
  border: solid 1px #34c0be;
  color: #34c0be;
  grid-column: -1/ -2;
  align-self: self-end;
  padding: 10px;
  margin-bottom: 3px;
}
.inputbox {
  width: 100px;
  height: 35px;
  padding: 4px;
  border: 1px solid #c6c9c8;
  border-radius: 4px;
  &:focus {
    outline: none;
    border: 2px solid #37c6c0;
  }
}
.searchclass {
  width: 30%;
}
.btnGrpClass {
  float: right;
}
.imgClass {
  width: 70px;
  height: 70px;
}
.uploadDiv {
  width: 10%;
  margin-left: auto;
  text-align: center;
  justify-content: end;
  padding: 4px 0px 0px 0px;
  button {
    cursor: pointer;
    width: 60%;
    height: 70%;
    border-radius: 4px;
    color: #5d409f;
    border: 1px solid #5d409f;
  }
  img {
    height: 70%;
    margin-bottom: -6px;
  }
}
.img-part {
  img {
    width: 100%;
  }
}
.align-filters {
  display: flex;
  margin: 30px 0 0 10px;
  *:nth-child(1) {
    text-align: center;
  }
  button {
    border-radius: 100px;
    background-color: #b2f8f7;
  }
}
.lop-report {
  .selectdiv {
    width: 50%;
    select {
      width: 50%;
      border-radius: 4px;
      outline: 0;
      font-size: 14px;
      color: #9f9da2;
      border: 1px solid #dadada;
      padding: 0 10px;

      &.errorr {
        border: 1px solid #e01717;
      }
      &.errorMessage {
        color: #e01717;
      }
    }
    span {
      font-size: 12px;
      margin-left: 3px;
      color: #9f9da2;
    }
  }
}
.export-emp {
  float: right;
  margin-bottom: 1%;
}
.export-section {
  margin-left: 6%;
  margin-top: 5px;
  align-items: center;
  display: flex;
}
.sorttext {
  text-align: center;
  line-height: 30px;
  color: #726f75;
  padding: 0px 0px 0px 10px;
}
.sorticons {
  width: 13%;
  padding: 8px 0px 5px 10px;
  span {
    padding-top: 10px;
    padding-left: 10px;
    border-left: 2px solid #34c0be;
  }
}
.selected-employees-list {
  display: flex;
  margin-top: 5%;
  margin-bottom: 5%;
}
.download-btn {
  margin-top: 2%;
}
.upload {
  display: flex;
  width: 30%;
  margin-top: 2%;
  flex-direction: column;
  align-items: center;
  background: linear-gradient(
      to right,
      lightgray 10px,
      rgba(255, 255, 255, 0) 0%
    ),
    linear-gradient(lightgray 10px, rgba(255, 255, 255, 0) 0%),
    linear-gradient(to right, lightgray 10px, rgba(255, 255, 255, 0) 0%),
    linear-gradient(lightgray 10px, rgba(255, 255, 255, 0) 0%);
  background-position: top, right, bottom, left;
  background-repeat: repeat-x, repeat-y;
  background-size: 20px 1px, 1px 20px;
  height: 140px;
}
.label {
  font-size: 12px;
  font-weight: 300;
  margin-bottom: 8px;
  color: #6e6e6e;
}
.upload-button {
  display: flex;
  align-items: center;
  label {
    cursor: pointer;
    border: 1px solid #5d409f;
    border-radius: 4px;
    padding: 6px 12px;
    font-size: 15px;
    color: #5d409f;
  }
  #upload-photo {
    opacity: 0;
    position: absolute;
    z-index: -1;
  }
  img {
    height: 19px;
    width: 19px;
    margin-right: 8px;
  }
}

.margintop-20 {
  margin-top: 20px;
}

.search-container {
  width: 30% !important;
  position: relative !important;
  max-width: 30% !important;
}

.remarks-grid {
  display: grid;
  grid-gap: 10px;
  grid-template-columns: 0.45fr 0.2fr;
  margin-bottom: 2%;
}

.permission-alert-msg {
  background-color: #f8d7da;
  padding: 1rem 1rem;
  margin-top: 1rem;
  margin-bottom: 1rem;
  font-weight: 600;
  color: #842029;
  border: 1px solid transparent;
  border-radius: .25rem;
  border-color: #f5c2c7;
}
</style>
